import {
  PublicSignupResponse,
  PublicSignupRequest,
} from '@electricjs/core_entity-client';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// This baseQuery does NOT add auth headers
const baseQuery = fetchBaseQuery({
  baseUrl: window._env_?.VITE_API_BASE_URL || '',
});

export const signupApiSlice = createApi({
  reducerPath: 'signupApiSlice',
  baseQuery,
  endpoints: builder => ({
    createGenericHRISOrganization: builder.mutation<
      PublicSignupResponse,
      PublicSignupRequest
    >({
      query: body => ({
        url: '/v3/signup',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreateGenericHRISOrganizationMutation } = signupApiSlice;
